import { ServiceBase, Result, PagedResult } from "./ServiceBase";
import { ProductInventoryInfo } from '../models/Product';
import { ProductAttribute } from "../models/ProductAttribute";
import { DetailsFilter } from "../pages/ProductSearch/ProductSearchResultFilters";
import ImpactPartnerService from "./ImpactPartnerService";

export class ProductInventorySearchFilter {
    impactPartnerId: string;
    productShortCode: string;
    productAssembly: string;
    productNumber: string;
    keywords: string;
    detailsFilters?: DetailsFilter[];
    userImpactPartnerId?: string;
    friendlySearchString: string;
};

export class ProductFamilyDescription {
    FullName: string;  
    ShortName: string;
    AssemblyId: string;
}

export class GetFiltersResult {
    
    FiltersForAssemblyId: string;
    Filters: ProductAttribute[];
    TotalFamilies: number;
}

export class GetProductFamilyDescriptionsResult {
    ProductFamilies: ProductFamilyDescription[];
    TotalFamilies: number;
}

export class GetQuantityResult {
    available: number;
    onOrder: number;
    callToBuy: number;
    isReadOnly: boolean;
}

export default class ProductInventoryService extends ServiceBase {
    public static async search(filter: ProductInventorySearchFilter, PageSize: number, Offset: number): Promise<Result<PagedResult<ProductInventoryInfo>>> {
        var result = await this.requestJson<PagedResult<ProductInventoryInfo>>({
            url: `/api/ProductInventory/SearchInventory/`,
            method: "POST",
            data: { ...filter, PageSize, Offset }
        }, null, null, Offset === 0);

        return result;
    }

    public static async getFilters(filter: ProductInventorySearchFilter): Promise<Result<GetFiltersResult>> {

        var result = await this.requestJson<GetFiltersResult>({
            url: `/api/ProductInventory/getFilters`,
            method: "POST",
            data: filter
        });
        
        return result;
    }

    public static async getProductFamilyDescriptions(filter: ProductInventorySearchFilter): Promise<Result<GetProductFamilyDescriptionsResult>> {

        var result = await this.requestJson<GetProductFamilyDescriptionsResult>({
            url: `/api/ProductInventory/getProductFamilyDescriptions`,
            method: "POST",
            data: filter
        });

        return result;
    }


    public static async searchProductNumbers(Keywords: string, PageSize: number, Offset: number): Promise<Result<PagedResult<string>>> {

        var result = await this.requestJson<PagedResult<string>>({
            url: `/api/ProductInventory/SearchProductNumbers`,
            method: "POST",
            data: { Keywords, PageSize, Offset }
        });

        return result;
    }

    public static async searchProductShortCodes(Keywords: string, PageSize: number, Offset: number): Promise<Result<PagedResult<string>>> {

        var result = await this.requestJson<PagedResult<string>>({
            url: `/api/ProductInventory/SearchProductShortCodes`,
            method: "POST",
            data: { Keywords, PageSize, Offset }
        });

        return result;
    }

    public static async getQuantity(partnerId: string, productNumber: string): Promise<Result<GetQuantityResult>> {

        var partnerResponse = await ImpactPartnerService.get(partnerId);
        var partner = partnerResponse.value;

        var result = await this.requestClietAuthJson<GetQuantityResult>(partner, {
            url: `/api/ProductInventory/GetQuantity`,
            method: "POST",
            data: { partnerId: partner.Id, productNumber }
        });

        return result;
    }
}
